import React, { useState } from 'react';
import { Card, Input, Button, Divider, Typography, Space, App, theme } from 'antd';
import { LockOutlined, UserOutlined, CalculatorOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../shared/session/authStore';
import { useAppColors } from '../../shared/theme';
import PlatformSsoButton from '../../features/platform-sso/PlatformSsoButton';
import PlatformTokenModal from '../../features/platform-token/PlatformTokenModal';

const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const c = useAppColors();
  const { token } = theme.useToken();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [tokenOpen, setTokenOpen] = useState(false);

  const handleLogin = async () => {
    if (!email.trim() || !password.trim()) return;
    setLoading(true);
    const ok = await useAuthStore.getState().login(email.trim(), password);
    setLoading(false);
    if (!ok) message.error(t('idea_calc.login.msg_login_error'));
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Фон страницы, а не полупрозрачная заливка: под ней белый body, и в тёмной
        // теме карточка входа висела на белом поле.
        background: token.colorBgLayout,
      }}
    >
      <Card style={{ width: 360, textAlign: 'center' }}>
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
          <CalculatorOutlined style={{ fontSize: 48, color: c.info }} />
          <Typography.Title level={4} style={{ margin: 0 }}>
            {t('idea_calc.header.logo_title')}
          </Typography.Title>
          <Input
            size="large"
            prefix={<UserOutlined />}
            placeholder={t('idea_calc.login.email')}
            type="text"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onPressEnter={handleLogin}
          />
          <Input.Password
            size="large"
            prefix={<LockOutlined />}
            placeholder={t('idea_calc.login.password')}
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onPressEnter={handleLogin}
          />
          <Button
            type="primary"
            size="large"
            block
            loading={loading}
            onClick={handleLogin}
          >
            {t('idea_calc.login.submit')}
          </Button>
          <Divider plain style={{ margin: 0 }}>
            {t('platform.ssoDivider')}
          </Divider>
          {/* Вход через платформу — вторичная дверь рядом с формой. Кнопка SSO сама
              скрывается там, где вход не настроен (stage/prod платформы), и тогда
              дверью платформы остаётся ручной токен — поэтому он здесь, а не в баннере
              над экраном, который дублировал кнопку ещё до входа. */}
          <PlatformSsoButton block appearance="brand" />
          <Button type="link" size="small" onClick={() => setTokenOpen(true)} style={{ padding: 0, height: 'auto' }}>
            {t('platform.signInWithToken')}
          </Button>
        </Space>
      </Card>
      <PlatformTokenModal open={tokenOpen} onClose={() => setTokenOpen(false)} />
    </div>
  );
};

export default LoginPage;
